module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/Rooms_02-01well.png";